import { UserPanel } from './UserPanel';
import { useAuth } from 'oidc-react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { setAuthState } from '../store/slice/UserSlice';
import { useDispatch } from 'react-redux';

/**
 * Renders a button for login and logout functionality
 * @param {IHeaderLoginProps} props the props required by the component
 * @returns {JSX.Element} the user menu component
 */
export const HeaderLogin = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auth = useAuth();

  const isLoggedin = auth?.userData;
  const userName = `${auth.userData?.profile.name}`;

  return isLoggedin ? (
    <UserPanel user={userName} />
  ) : (
    <Button
      color="inherit"
      onClick={() => {
        dispatch(setAuthState('login'));
        auth.signIn();
      }}
    >
      {t('button.login')}
    </Button>
  );
};
